import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carhireforoutstationinmumbai() {



    const cardData = {





keyword: "Car Hire for Outstation in Mumbai",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Car Hire for Outstation in Mumbai for family trips, corporate travel, business meetings, weekend getaways, pilgrimage tours, destination weddings, sightseeing holidays, and long-distance journeys across Maharashtra and India. We offer a wide range of chauffeur-driven vehicles including Sedan, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Tempo Traveller, Urbania, Mini Bus, and luxury cars according to your travel needs. Our outstation car hire service includes experienced drivers, clean and well-maintained vehicles, transparent pricing, flexible booking options, doorstep pickup, and 24/7 customer support to make your journey smooth and stress-free. Whether you require a one-way cab, round-trip car rental, multi-day tour package, or customized travel plan, Shreesha Tours & Travels ensures safe, comfortable, and affordable transportation from Mumbai to popular destinations across Maharashtra. Travel with complete convenience and explore beautiful hill stations, beaches, temples, heritage places, and business cities with our professional outstation car rental services.",

topPlaces: [
  {
    title: "Mumbai to Bhandardara",
    description: "Bhandardara is a peaceful hill destination known for Arthur Lake, Randha Falls, Wilson Dam, and scenic Sahyadri landscapes. It is an excellent choice for nature lovers and weekend travelers."
  },
  {
    title: "Mumbai to Igatpuri",
    description: "Igatpuri is famous for misty mountains, waterfalls, trekking spots, and Vipassana International Academy. It is a popular destination for relaxation, adventure, and family holidays."
  },
  {
    title: "Mumbai to Khandala",
    description: "Khandala is a scenic hill station known for beautiful valleys, viewpoints, waterfalls, and pleasant weather. It is a perfect getaway for couples and families from Mumbai."
  },
  {
    title: "Mumbai to Bhimashankar",
    description: "Bhimashankar is one of the twelve Jyotirlingas and a famous pilgrimage destination surrounded by dense forests and natural beauty. It is ideal for religious and nature tours."
  },
  {
    title: "Mumbai to Akkalkot",
    description: "Akkalkot is a major spiritual destination known for Shri Swami Samarth Maharaj Temple. Devotees frequently hire private cars for comfortable pilgrimage travel."
  },
  {
    title: "Mumbai to Tuljapur",
    description: "Tuljapur is famous for Tulja Bhavani Temple and holds great religious importance in Maharashtra. Private car hire services provide convenient travel for families and senior citizens."
  },
  {
    title: "Mumbai to Pandharpur",
    description: "Pandharpur is a sacred pilgrimage destination known for Shri Vitthal Rukmini Temple. It attracts thousands of devotees and is one of the most popular religious routes from Mumbai."
  },
  {
    title: "Mumbai to Ratnagiri",
    description: "Ratnagiri is a beautiful Konkan destination famous for beaches, Ganpatipule Temple, forts, and Alphonso mango orchards. It is perfect for scenic coastal road trips."
  },
  {
    title: "Mumbai to Sindhudurg",
    description: "Sindhudurg is known for Sindhudurg Fort, Tarkarli Beach, scuba diving, and beautiful Konkan coastline. It is a great destination for family vacations and group tours."
  },
  {
    title: "Mumbai to Gokarna",
    description: "Gokarna is a peaceful coastal destination famous for Om Beach, Kudle Beach, temples, and scenic landscapes. It is a popular choice for travelers looking for a relaxing beach holiday."
  }
],




"services": [
  {
    "name": "Car Hire for Outstation in Mumbai",
    "description": "Book Car Hire for Outstation in Mumbai for comfortable and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cars for family vacations, business trips, airport transfers, pilgrimage tours, and interstate journeys with flexible one way and round trip options."
  },
  {
    "name": "Mumbai Outstation Car Hire",
    "description": "Choose Mumbai Outstation Car Hire for safe and convenient travel across Maharashtra and India. Enjoy chauffeur-driven vehicles, experienced drivers, transparent pricing, doorstep pickup, and comfortable travel solutions for personal trips, corporate journeys, family tours, and weekend getaways."
  },
  {
    "name": "Outstation Car Rental Mumbai",
    "description": "Book Outstation Car Rental Mumbai for affordable and dependable transportation with a wide range of vehicles. Our rental services are suitable for long-distance travel, sightseeing tours, business trips, family holidays, and religious journeys with professional driver support."
  },
  {
    "name": "Car Rental for Outstation Mumbai",
    "description": "Reserve Car Rental for Outstation Mumbai with flexible travel plans, clean AC cars, and experienced chauffeurs. Enjoy convenient transportation for one way drops, round trips, airport transfers, holiday tours, and interstate travel with complete comfort."
  },
  {
    "name": "Mumbai Outstation Cab Booking",
    "description": "Complete Mumbai Outstation Cab Booking with quick confirmation, affordable fares, and multiple vehicle options. Get reliable cab services for short and long-distance routes with professional drivers, comfortable seating, and 24x7 travel assistance."
  },
  {
    "name": "Car Hire with Driver Mumbai",
    "description": "Choose Car Hire with Driver Mumbai for stress-free travel with skilled chauffeurs and premium vehicles. Ideal for airport transfers, corporate meetings, family outings, weddings, sightseeing tours, and outstation journeys with complete safety and convenience."
  },
  {
    "name": "Mumbai Long Distance Car Rental",
    "description": "Book Mumbai Long Distance Car Rental for comfortable interstate and intercity travel with spacious vehicles and experienced drivers. Perfect for extended road trips, business travel, family vacations, and multi-city journeys across India."
  },
  {
    "name": "Mumbai One Way Car Hire",
    "description": "Choose Mumbai One Way Car Hire for affordable drop taxi services without return fare charges. Enjoy fixed pricing, convenient pickup locations, comfortable AC vehicles, and professional chauffeur service for hassle-free one way travel."
  },
  {
    "name": "Mumbai Round Trip Car Hire",
    "description": "Reserve Mumbai Round Trip Car Hire for return journeys with flexible schedules and comfortable travel packages. Ideal for sightseeing, family tours, pilgrimage trips, weekend holidays, and business travel requiring reliable transportation."
  },
  {
    "name": "Mumbai Airport Outstation Car Hire",
    "description": "Book Mumbai Airport Outstation Car Hire for smooth airport transfers to destinations across India. Get timely pickup and drop services, luggage-friendly vehicles, professional chauffeurs, and comfortable travel from Mumbai Airport to your preferred location."
  },
  {
    "name": "Mumbai Family Trip Car Rental",
    "description": "Choose Mumbai Family Trip Car Rental for safe and spacious travel with comfortable vehicles suitable for families. Perfect for vacations, temple visits, hill station trips, sightseeing tours, and weekend getaways with experienced drivers."
  },
  {
    "name": "Mumbai Corporate Car Hire",
    "description": "Book Mumbai Corporate Car Hire for executive travel, employee transportation, client meetings, airport transfers, conferences, and business events. Enjoy punctual service, premium vehicles, professional chauffeurs, and reliable corporate transportation solutions."
  },
  {
    "name": "Affordable Outstation Car Rental Mumbai",
    "description": "Find Affordable Outstation Car Rental Mumbai with budget-friendly packages, quality vehicles, and experienced drivers. Travel comfortably for personal trips, family holidays, business journeys, and long-distance routes with reliable service at competitive prices."
  },
  {
    "name": "Best Car Hire Service Mumbai",
    "description": "Choose the Best Car Hire Service Mumbai for premium chauffeur-driven transportation with a wide fleet of vehicles, professional drivers, transparent pricing, and excellent customer support. Whether you need airport transfers, outstation travel, corporate transportation, family tours, or one way car hire, our services provide safe, comfortable, and reliable travel experiences across India."
  }
],
"tableData": [
  ["Car Hire for Outstation in Mumbai", "Mumbai Outstation Car Hire"],
  ["Outstation Car Rental Mumbai", "Car Rental for Outstation Mumbai"],
  ["Mumbai Outstation Cab Booking", "Car Hire with Driver Mumbai"],
  ["Mumbai Long Distance Car Rental", "Mumbai One Way Car Hire"],
  ["Mumbai Round Trip Car Hire", "Mumbai Airport Outstation Car Hire"],
  ["Mumbai Family Trip Car Rental", "Mumbai Corporate Car Hire"],
  ["Affordable Outstation Car Rental Mumbai", "Best Car Hire Service Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Car Hire for Outstation Travel in Mumbai",
    WhyChoosedescription: "Shreesha Travels provides dependable car hire services in Mumbai for outstation journeys, offering comfortable chauffeur-driven vehicles for family vacations, business trips, weekend getaways, pilgrimage tours, and long-distance travel across India."
  },
  {
    WhyChooseheading: "Convenient Travel Beyond City Limits",
    WhyChoosedescription: "From Mumbai, hire a car for popular destinations like Pune, Lonavala, Mahabaleshwar, Nashik, Shirdi, Goa, Kolhapur, Surat, Ahmedabad, Indore, Bengaluru, Jaipur, and many other cities with complete travel flexibility."
  },
  {
    WhyChooseheading: "Wide Selection of Cars for Every Group Size",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan Cars, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses based on your passenger count, luggage, and journey requirements."
  },
  {
    WhyChooseheading: "Ideal for Holidays, Business & Religious Tours",
    WhyChoosedescription: "Our outstation car hire service is suitable for family trips, corporate travel, temple visits, sightseeing tours, destination weddings, medical travel, and customized road journeys."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "Select a travel plan that matches your requirement with one-way cab booking, round trips, multi-day rentals, airport transfers, and personalized itineraries available."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Comfortable Journeys",
    WhyChoosedescription: "Our skilled drivers understand major highways and travel routes, ensuring safe driving, punctual pickups, and a smooth journey from Mumbai to your destination."
  },
  {
    WhyChooseheading: "Well-Maintained Vehicles for Long Routes",
    WhyChoosedescription: "Every rental car is regularly serviced, cleaned, air-conditioned, and inspected before every trip to provide passengers with a safe and comfortable outstation experience."
  },
  {
    WhyChooseheading: "Book Outstation Car Hire with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent fares, quick booking support, flexible travel arrangements, and reliable chauffeur-driven cars for your next outstation journey from Mumbai."
  }
]

};

const faqData = [
  {
    question: "What is included in outstation car hire from Mumbai?",
    answer: "Our outstation car hire includes a comfortable vehicle with a professional driver for one-way trips, round journeys, multi-day tours, and customized travel plans."
  },
  {
    question: "Can I hire a car from Mumbai for a one-way destination?",
    answer: "Yes, one-way car hire services are available for travellers who need direct transportation to their destination without a return trip."
  },
  {
    question: "Which vehicles can I hire for outstation travel?",
    answer: "You can choose from Sedan cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses."
  },
  {
    question: "Are outstation cars available for family vacations?",
    answer: "Yes, our spacious vehicles are perfect for family holidays, weekend trips, sightseeing tours, and long-distance road travel."
  },
  {
    question: "Can I hire a car for pilgrimage destinations?",
    answer: "Yes, we provide cars for religious journeys including Shirdi, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga tours, and other spiritual destinations."
  },
  {
    question: "Do you provide cars for corporate outstation travel?",
    answer: "Yes, companies can hire vehicles for business meetings, employee travel, client visits, conferences, and official tours."
  },
  {
    question: "Can I book an outstation car for multiple days?",
    answer: "Yes, multi-day car rental packages are available for vacations, road trips, business tours, and customized travel schedules."
  },
  {
    question: "How is the outstation car hire fare calculated?",
    answer: "The charges depend on the vehicle category, distance, number of travel days, destination, route, and selected package."
  },
  {
    question: "Can I customize my outstation travel plan?",
    answer: "Yes, you can customize routes with sightseeing stops, multiple destinations, overnight stays, and preferred travel schedules."
  },
  {
    question: "How can I book a Car Hire for Outstation in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harish Mehta",
    feedback: "The complete outstation travel arrangement was excellent. The vehicle was comfortable, the driver was professional, and the journey was managed smoothly from Mumbai to our destination.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Joshi",
    feedback: "Our family trip became easy and enjoyable with the reliable car hire service. The clean vehicle, comfortable ride, and timely support made the journey memorable.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Hire for Outstation in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/car-hire-for-outstation-in-mumbai.webp",
  "description":
    "Book Car Hire for Outstation in Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable outstation car rental services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cars with professional drivers available 24x7 for one-way trips, round trips, family vacations, business travel, airport transfers, and long-distance journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/car-hire-for-outstation-in-mumbai"
  }
};




    return (
        <div>
<Helmet>
  <title>Car Hire for Outstation in Mumbai | Outstation Car Rental | +91 8355835813</title>

  <meta
    name="description"
    content="Book Car Hire for Outstation in Mumbai with Shreesha Travels for reliable outstation car rental services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with driver for one-way, round-trip, family, corporate, and long-distance travel with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Car Hire for Outstation in Mumbai, Mumbai Outstation Car Hire, Outstation Car Rental Mumbai, Car Rental for Outstation Mumbai, Mumbai Outstation Car Booking, Outstation Cab Mumbai, Mumbai Long Distance Car Hire, One Way Car Hire Mumbai, Round Trip Car Rental Mumbai, Mumbai Outstation Taxi Service, Chauffeur Driven Car Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Carhireforoutstationinmumbai;